import { useState, useEffect, useReducer, useCallback } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";
import { socketConnection } from "../../services/socket";

const reducer = (state, action) => {
  if (action.type === "LOAD_WHATSAPPS") {
    const whatsApps = action.payload;

    return [...whatsApps];
  }

  if (action.type === "UPDATE_WHATSAPPS") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex] = whatsApp;
      return [...state];
    } else {
      return [whatsApp, ...state];
    }
  }

  if (action.type === "UPDATE_SESSION") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex].status = whatsApp.status;
      state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
      state[whatsAppIndex].qrcode = whatsApp.qrcode;
      state[whatsAppIndex].retries = whatsApp.retries;
      return [...state];
    } else {
      return [...state];
    }
  }

  if (action.type === "DELETE_WHATSAPPS") {
    const whatsAppId = action.payload;

    const whatsAppIndex = state.findIndex((s) => s.id === whatsAppId);
    if (whatsAppIndex !== -1) {
      state.splice(whatsAppIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

// Reducer para progresso de sincronização
const syncProgressReducer = (state, action) => {
  if (action.type === "UPDATE_SYNC_PROGRESS") {
    return {
      ...state,
      [action.payload.whatsappId]: action.payload
    };
  }

  if (action.type === "REMOVE_SYNC_PROGRESS") {
    const newState = { ...state };
    delete newState[action.payload];
    return newState;
  }

  if (action.type === "RESET") {
    return {};
  }

  return state;
};

const useWhatsApps = () => {
  const [whatsApps, dispatch] = useReducer(reducer, []);
  const [syncProgress, dispatchSyncProgress] = useReducer(syncProgressReducer, {});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fetchSession = async () => {
      try {
        const { data } = await api.get("/whatsapp/?session=0");
        dispatch({ type: "LOAD_WHATSAPPS", payload: data });
        setLoading(false);
      } catch (err) {
        setLoading(false);
        toastError(err);
      }
    };
    fetchSession();
  }, []);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketConnection({ companyId });

    socket.on(`company-${companyId}-whatsapp`, (data) => {
      if (data.action === "update") {
        dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
      }
    });

    socket.on(`company-${companyId}-whatsapp`, (data) => {
      if (data.action === "delete") {
        dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
      }
    });

    socket.on(`company-${companyId}-whatsappSession`, (data) => {
      if (data.action === "update") {
        dispatch({ type: "UPDATE_SESSION", payload: data.session });
      }
    });

    // Listener para progresso de sincronização de histórico
    socket.on(`company-${companyId}-whatsapp-sync-progress`, (data) => {
      console.log("📥 Sync progress received:", data);
      dispatchSyncProgress({ type: "UPDATE_SYNC_PROGRESS", payload: data });

      // Remove automaticamente após 8 segundos se completou, deu erro ou está desabilitado
      if (data.status === "completed" || data.status === "error" || data.status === "disabled") {
        setTimeout(() => {
          dispatchSyncProgress({ type: "REMOVE_SYNC_PROGRESS", payload: data.whatsappId });
        }, 8000);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  // Função para remover progresso manualmente
  const removeSyncProgress = useCallback((whatsappId) => {
    dispatchSyncProgress({ type: "REMOVE_SYNC_PROGRESS", payload: whatsappId });
  }, []);

  return { whatsApps, loading, syncProgress, removeSyncProgress };
};

export default useWhatsApps;
